import * as React from 'react';
import { Box, Typography } from '@mui/material';
var ApplicationContextBar = function (_a) {
    var title = _a.title, items = _a.items;
    return (React.createElement(Box, { className: "context-bar" },
        React.createElement(Typography, { component: "h2", className: "context-bar-title" }, title),
        React.createElement(Box, { className: "context-chips" }, items.map(function (item) { return (React.createElement(Box, { key: item.key, className: "context-chip" },
            React.createElement(Typography, { component: "span", className: "context-chip-label" },
                item.label,
                ":"),
            React.createElement(Typography, { component: "span", className: "context-chip-value" }, item.value))); }))));
};
export default React.memo(ApplicationContextBar);
